module.exports = __webpack_public_path__ + "img/woer.d4debece.png";